export default __webpack_public_path__ + "images/0x6ab6d61428fde76768d7b45d8bfeec19c6ef91a8.png";